
//
// Admin Controller
//
// General, non-view-specific functions for the admin panel.
//
// Responsibilities:
// - Run LOM Timer
// - Detect and warn about changes to forms
//

module.exports = function AdminController ($page, $$) {

  // Dom
  var $allFormInputs = $$('input,textarea,select');
  var $allForms      = $$('form');

  // Config
  var timeout = $page.data('admin-controller-lom-timeout') || 30;

  // State
  var state = {
    timer: { cancel: id },
    form: {
      modified: false,
      submitting: false
    }
  };

  // Functions
  function lockScreen () {
    state.timer.cancel();
    console.warn('LOCK ENGAGED');
    window.location = '/admin/lock';
  }

  function resetTimer () {
    state.timer.cancel();
    state.timer = delay(timeout * 60, lockScreen);
  }

  function setFormModified () {
    console.info('AdminController::setFormModified - form modification detected');
    state.form.modified = true;
  }

  function setFormSubmitting () {
    state.form.submitting = true;
  }

  function checkFormIsModified () {
    if (state.form.submitting) return undefined;
    if (state.form.modified) {
      var confirmationMessage = 'Do you want to save this page? Changed you made may not be saved.';
      (event || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    }
  }

  // Listeners: LOM Timer
  document.addEventListener('click',     resetTimer);
  document.addEventListener('keypress',  resetTimer);
  document.addEventListener('touchmove', resetTimer);
  document.addEventListener('mousemove', resetTimer);
  document.addEventListener('keypress',  whichKeyMod(KEY_GRAVE, MOD_CTRL, lockScreen));

  // Listeners: Form monitor
  //$allFormInputs.on('change', setFormModified);
  //$allForms.on('submit', setFormSubmitting);
  //window.addEventListener('beforeunload', checkFormIsModified);

  // Init
  console.green('AdminController - LOM timer set to ' + timeout + ' minutes.');
  resetTimer();

}

